import type { ManifestRouteDefinition } from '@/core/manifest/types'

// API paths below are relative to VITE_API_URL
// (https://api-dev.akashic.dhira.io/tenant-admin/api/v1) and match the
// tenant-admin Swagger contract.
export const roleRouteRoot: ManifestRouteDefinition = {
  key: 'role',
  path: '/roles',
  // isPublic skips ProtectedRoute + PermissionGate (inherited by children) —
  // same as the ADP routes during this build phase. API calls still send the
  // Bearer token from localStorage; this only stops the route guards from
  // bouncing you to login while the auth/RBAC wiring is in flux.
  isPublic: true,
  apiCalls: [
    { url: '/roles', method: 'GET' },
    { url: '/roles/modules', method: 'GET' },
    { url: '/roles/:roleId', method: 'GET' },
    { url: '/roles', method: 'POST' },
    { url: '/roles/:roleId', method: 'PATCH' },
    { url: '/roles/:roleId', method: 'DELETE' },
    { url: '/roles/:roleId/duplicate', method: 'POST' },
    { url: '/roles/:roleId/restore', method: 'POST' },
  ],
  lazyComponent: () =>
    import('@/features/role/pages/RoleLayout/RoleLayout').then((m) => ({
      default: m.default,
    })),
  indexRedirect: 'active',
  children: [
    {
      key: 'role_active',
      path: 'active',
      apiCalls: [
        { url: '/roles', method: 'GET' },
        { url: '/roles/:roleId', method: 'DELETE' },
        { url: '/roles/:roleId/duplicate', method: 'POST' },
      ],
      lazyComponent: () =>
        import('@/features/role/pages/RoleActivePage/RoleActivePage').then((m) => ({
          default: m.default,
        })),
    },
    {
      key: 'role_deleted',
      path: 'deleted',
      apiCalls: [
        { url: '/roles', method: 'GET' },
        { url: '/roles/:roleId/restore', method: 'POST' },
      ],
      lazyComponent: () =>
        import('@/features/role/pages/RoleDeletedPage/RoleDeletedPage').then((m) => ({
          default: m.default,
        })),
    },
    {
      key: 'role_create',
      path: 'create',
      apiCalls: [
        { url: '/roles/modules', method: 'GET' },
        { url: '/roles', method: 'POST' },
      ],
      lazyComponent: () =>
        import('@/features/role/pages/RoleCreatePage/RoleCreatePage').then((m) => ({
          default: m.default,
        })),
    },
    {
      key: 'role_edit',
      path: ':roleId/edit',
      apiCalls: [
        { url: '/roles/modules', method: 'GET' },
        { url: '/roles/:roleId', method: 'GET' },
        { url: '/roles/:roleId', method: 'PATCH' },
      ],
      lazyComponent: () =>
        import('@/features/role/pages/RoleEditPage/RoleEditPage').then((m) => ({
          default: m.default,
        })),
    },
  ],
}
